import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import useKeyPress from '../../../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../../../views/textNumberEntryView';
import NumberView from '../../../../views/numberTNView';
import MenuContext from '../../../../../context/menuContext';
import ValuesContext from '../../../../../context/valuesContext';

function FaultDelayTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);
  const {selected, setDisableMenu} = useContext(MenuContext);
  const {values, onUpdateValues} = useContext(ValuesContext);

  const onRightHold = useCallback(
    result => {
      setDisableMenu(true);
      onExit();
      onUpdateValues(selected.id, result);
      setTimeout(() => setDisableMenu(false), 500);
    },
    [value],
  );

  return (
    <NumberView
      chars={numbers}
      focus={10}
      onChange={v => setValue(v)}
      defaultKey1={2}
      defaultKey2={2}
      defaultKey3={2}
      defaultKey4={2}
      defaultKey5={2}
      defaultKey6={2}
      defaultKey7={2}
      defaultKey8={2}
      defaultKey9={0}
      defaultKey10={3}
      defaultKey11={12}
      defaultKey12={2}
      onSave={onRightHold}
      onLeftHold={onExit}
      title="Fault Delay Alert"
      caption=""
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default FaultDelayTN;
